import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const ClientSignUpPage = React.lazy(() => import(/* webpackChunkName: "ClientSignUp" */ './Page'));
export const ClientSignUp = () => (React.createElement(Page, { title: "Sign up", description: "New account or signup for client.", keywords: "Client Signup, Client, Signup Client, New account Client" },
    React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
        React.createElement(ClientSignUpPage, null))));
